import type { Item, List } from '../domain/models'

export function selectSortedListItems(list: List | null | undefined): Item[] {
  const itemsById = list?.items ?? {}
  const items = Object.values(itemsById)

  items.sort(compareListItemsDeterministically)
  return items
}

function compareListItemsDeterministically(a: Item, b: Item): number {
  if (a.order !== b.order) return a.order - b.order

  // ISO timestamps are lexicographically sortable and deterministic.
  if (a.createdAt !== b.createdAt) return a.createdAt.localeCompare(b.createdAt)

  return a.id.localeCompare(b.id)
}
